import axiosInstance from '@/axiosInstance.ts'

interface SubmitSurveyData {
    flow: string
    notes: string
    rating: number
    thread_id: string
}

export const httpSubmitSurvey = (data: SubmitSurveyData) => {
    const url = `/chatbot/rate`
    return axiosInstance.post(url, data)
}
